import React from "react";
import { Link } from "react-router-dom";
import useFormValidationForgotPassword from "../../Hooks/ForgotpasswordHook";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";
import { ReactComponent as BlackVatugIcon } from "../../Asset/black.svg";
import { useNavigate } from "react-router-dom";
import "./Forgotpassword.css"

const ForgotPassword = () => {
  const navigate = useNavigate()
  const {
    email,
    error,
    successMessage,
    isLoading,
    handleInputChange,
    handleSubmit,
  } = useFormValidationForgotPassword();
  const {userType} = useContext(AuthContext)

  return (
    <div className="forgotten-pass-container">
      <div className="content-card">
      <div className="wrap">
        <BlackVatugIcon onClick={() => navigate("/")}/>
        <Link to="/" >Back</Link>
        </div>
        <form onSubmit={handleSubmit}>
        <h3>Forgot Password</h3>
        <p>For {userType}</p>
          <label>
            Email Address
            <input
              type="email"
              name="email"
              value={email}
              onChange={handleInputChange}
            />
          {error && <p className="error">{error}</p>}
          </label>
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Validating..." : "Continue"}
          </button>
          {successMessage && <p className="success">{successMessage}</p>}
        </form>
      </div>
      <div className="img"></div>
    </div>
  );
};

export default ForgotPassword;